import { render, staticRenderFns } from "./CardListCategories.vue?vue&type=template&id=52abeec0"
import script from "./CardListCategories.vue?vue&type=script&lang=js"
export * from "./CardListCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52abeec0')) {
      api.createRecord('52abeec0', component.options)
    } else {
      api.reload('52abeec0', component.options)
    }
    module.hot.accept("./CardListCategories.vue?vue&type=template&id=52abeec0", function () {
      api.rerender('52abeec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CardListCategories.vue"
export default component.exports